export const MUMBAI = {
  chainId: 80001,
  name: 'Mumbai',
  currency: 'MATIC',
  explorerUrl: 'https://mumbai.polygonscan.com',
  rpcUrl: 'https://rpc-mumbai.maticvigil.com',
}

export const MAINNET = {
  chainId: 1,
  name: 'Mainnet',
  currency: 'ETH',
  explorerUrl: 'https://etherscan.io',
  rpcUrl: 'https://eth.llamarpc.com',
}

export const BLAST = {
  chainId: Number(process.env.REACT_APP_BLAST_NETWORK_ID ?? 81457),
  name: 'Blast',
  currency: 'ETH',
  explorerUrl: process.env.REACT_APP_BLAST_BLOCK_EXPLORER_URL ?? '',
  rpcUrl: process.env.REACT_APP_BLAST_RPC ?? '',
}

export const BASE = {
  chainId: Number(process.env.REACT_APP_BASE_NETWORK_ID ?? 8453),
  name: 'Base',
  currency: 'ETH',
  explorerUrl: process.env.REACT_APP_BASE_BLOCK_EXPLORER_URL ?? '',
  rpcUrl: process.env.REACT_APP_BASE_RPC ?? '',
}

export const metadata = {
  name: 'ZAP',
  description: 'Fund. Incubate. Launch.',
  url: process.env.REACT_APP_FRONT_END_URL ?? '',
  icons: [
    'https://assets-global.website-files.com/65858ffa5f93fd84c2da4fdb/6586bc0b66809383c7247095_zap-favicon.png',
  ],
}
